<script setup>
import { useCartStore } from '~/stores/cartStore'
import { computed } from 'vue'

const cartStore = useCartStore()

const totalItems = computed(() => {
  return cartStore.totalItems
})

const totalCost = computed(() => {
  return cartStore.totalCost
})
</script>

<template>
  <Transition name="slide-up">
    <div v-if="totalItems > 0" class="fixed bottom-0 left-0 right-0 p-4 z-50 pointer-events-none flex justify-center">
      <NuxtLink to="/cart" class="pointer-events-auto w-full max-w-md">
        <div class="bg-primary text-primary-content px-6 py-4 rounded-2xl shadow-2xl flex items-center justify-between transition-transform active:scale-95">
          <div class="flex items-center gap-4">
            <div class="bg-primary-content/20 p-2 rounded-xl">
              <div class="indicator">
                <span class="indicator-item badge badge-secondary badge-sm">{{ totalItems }}</span>
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
            </div>
            <div>
              <p class="font-bold text-lg">View Cart</p>
              <p class="text-xs opacity-80">{{ totalItems }} items added</p>
            </div>
          </div>
          <div class="text-right">
            <p class="text-xs opacity-80">Total</p>
            <p class="font-bold text-xl">Tk {{ totalCost }}</p>
          </div>
        </div>
      </NuxtLink>
    </div>
  </Transition>
</template>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
  transition: all 0.3s ease-out;
}

.slide-up-enter-from,
.slide-up-leave-to {
  transform: translateY(100%);
  opacity: 0;
}
</style>
